export default __webpack_public_path__ + "static/media/glow.8ac237f4.svg";